import Vue from 'vue'

const state = {
  users: {}
}

const mutations = {
  FETCH (state, users) {
    state.users = users
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('users')
      .then(response => {
        commit('FETCH', response.data)
      })
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
